/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable jsx-a11y/label-has-associated-control */
import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { GeoAutoCompletion } from "components/GeoAutoCompletion";
import { TextField } from "components/TextField";
import { DISTANCES } from "config/constants";
import { theme } from "config/theme";
import { DAILYSLOTS, Slot } from "constants/slot";
import useText from "constants/text";
import { addDays, eachWeekendOfInterval, isSunday } from "date-fns";
import { VehicleRadio } from "domains/Task/components/Job/Radio";
import HolidaysDialog from "domains/Task/components/Job/dialogs/HolidaysDialog";
import { Address, JobItemsInput, JobType, JobVehicleType } from "generated/graphql";
import { useCurrentClient } from "hooks";
import { useDeliverySlots, useHupAdress } from "hooks/useCurrentUser";
import { MotorCycleIcon, TreeCycleIcon, TruckIcon, VanIcon, VanXlIcon } from "icons";
import { CountryCode } from "libphonenumber-js";
import moment from "moment";
import React, { useEffect } from "react";
import "styled-components/macro";
import { getHours, isCurrentDay, isToday, isWeekEnd } from "utils";
import { isHoliday } from "utils/date";
import { NewJobContext } from "../context";
import { useJobInfoStyles } from "../styles";
import { distanceMetrixService, getContryCode } from "../utils";

export interface IProps {
  onNext?: React.Dispatch<React.SetStateAction<number>>;
}
const defaultAddress: Address = {
  address: "",
  place_id: "",
  additional_address: "",
};
const defaultJob: JobItemsInput = {
  job_type: JobType.Pickup,
  job_address: defaultAddress,
  job_date: moment().format("YYYY-MM-DD"),
  job_vehicle_type: JobVehicleType.Scooter,
  job_time: DAILYSLOTS.morning,
};

const currentHours = new Date().getHours();

export function NewJobInfos({ onNext }: IProps) {
  const styles = useJobInfoStyles();
  const { setJob } = React.useContext(NewJobContext);
  const [jobInfos, setJobInfos] = React.useState<JobItemsInput>(defaultJob);
  const [distance, setDistance] = React.useState<number>(0);
  const { client } = useCurrentClient();
  const { text } = useText();
  const [open, setOpen] = React.useState(false);
  const {
    morningSlotStart,
    morningSlotEnd,
    afternoonSlotStart,
    afternoonSlotEnd,
    allDaySlotStart,
    allDaySlotEnd,
  } = useDeliverySlots() || {};
  const [slotsPickup, setSlotsPickup] = React.useState<Slot[]>([]);
  const [dailySlot, setDailySlot] = React.useState<any>({
    dropMorning: "",
    morning: "",
    afternoon: "",
  });
  useEffect(() => {
    setSlotsPickup([
      {
        label: `${morningSlotStart}:00-${morningSlotEnd}:00`,
        start: `${morningSlotStart}:00`,
        end: `${morningSlotEnd}:00`,
        type: "PICKUP",
      },
      {
        label: `${afternoonSlotStart}:00-${afternoonSlotEnd}:00`,
        start: `${afternoonSlotStart}:00`,
        end: `${afternoonSlotEnd}:00`,
        type: "PICKUP",
      },
      {
        label: `${allDaySlotStart}:00-${allDaySlotEnd}:00`,
        start: `${allDaySlotStart}:00`,
        end: `${allDaySlotEnd}:00`,
        type: "DROPOFF",
      },
      {
        label: `${allDaySlotStart}:00-${allDaySlotEnd}:00`,
        start: `${allDaySlotStart}:00`,
        end: `${allDaySlotEnd}:00`,
        type: "FROM_STOCK",
      },
    ]);
    setDailySlot({
      dropMorning: `${allDaySlotStart}:00`,
      morning: `${morningSlotStart}:00`,
      afternoon: `${afternoonSlotStart}:00`,
    });
    setJobInfos((prev) => ({
      ...prev,
      job_time: `${morningSlotStart}:00`,
    }));
  }, [morningSlotStart, morningSlotEnd, afternoonSlotStart, afternoonSlotEnd, allDaySlotStart, allDaySlotEnd]);

  React.useEffect(() => {
    if (client) {
      setJobInfos((prev) => ({
        ...prev,
        job_address: {
          place_id: client?.client_address?.place_id,
          address: client?.client_address?.address,
        },
      }));
    }
  }, [client]);
  const isMorning = (date = new Date()) => date.getHours() < morningSlotStart;
  const isAfternoom = (date = new Date()) => date.getHours() >= afternoonSlotStart;
  const isInvalidTime = (): boolean => {
    return (
      isCurrentDay(jobInfos.job_date) &&
      ((isAfternoom() && getHours(jobInfos.job_time) >= afternoonSlotStart) || (!isMorning() && getHours(jobInfos.job_time) <= morningSlotStart))
    );
  };
  useEffect(() => {
    setJobInfos((prev) => ({
      ...prev,
      job_time: isInvalidTime() ? dailySlot?.afternoon : jobInfos?.job_time,
    }));
  }, [dailySlot, jobInfos.job_type]);

  React.useEffect(() => {
    if (!distanceMetrixService.current && (window as any).google && jobInfos?.job_address) {
      distanceMetrixService.current = new (window as any).google.maps.DistanceMatrixService();
    }
    if (!distanceMetrixService.current) {
      return undefined;
    }

    if (jobInfos?.job_address?.address === "") return undefined;

    const pieces = jobInfos?.job_address?.address?.split(/[\s,]+/) || ["Sénégal"];
    const country = pieces[pieces.length - 1];
    const countryCode = getContryCode(country);
    const defaultAdress = useHupAdress(countryCode as CountryCode);
    (distanceMetrixService.current as any).getDistanceMatrix(
      {
        origins: [defaultAdress],
        destinations: [jobInfos.job_address?.address],
        travelMode: "DRIVING",
      },
      callback
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobInfos.job_address]);

  function callback(response: any, status: string) {
    if (status === "OK") {
      setDistance(response?.rows[0]?.elements[0]?.distance?.value);
    }
  }

  const handleNext = () => {
    setJob(jobInfos);
    onNext(1);
  };
  const isNotPickup = React.useCallback(
    () => jobInfos.job_type.includes("DROPOFF") || jobInfos.job_type.includes("FROM_STOCK"),
    [jobInfos.job_type]
  );
  React.useEffect(() => {
    if (jobInfos) {
      if (isNotPickup()) {
        setJobInfos((prev) => ({ ...prev, job_time: dailySlot?.dropMorning }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobInfos.job_type]);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();
    if (event.target.name === "job_date") {
      if (isHoliday(event.target.value)) {
        setOpen(true);
        return;
      }
    }
    setJobInfos((prev: JobItemsInput) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  const hasValidFields = (ingoredFields: string[]) =>
    !Object.entries(jobInfos).find(([key, value]) => !ingoredFields.includes(key) && !value);
  const hasValidAdress = () => jobInfos.job_address && jobInfos.job_address.address && jobInfos.job_address.place_id;

  const handleAddressChange = (values: any) => {
    setJobInfos((prev) => ({ ...prev, job_address: values }));
  };

  const isValidForm = () => {
    if (!isNotPickup()) {
      return hasValidAdress();
    }
    return hasValidFields(["job_vehicule_type", "job_address"]);
  };

  const minDay = React.useMemo(() => {
    if (
      distance >= DISTANCES.D_50 &&
      (jobInfos.job_vehicle_type === JobVehicleType.Scooter || jobInfos.job_vehicle_type === JobVehicleType.Tricycle)
    ) {
      setJobInfos((p) => ({ ...p, job_vehicle_type: JobVehicleType.MiniVan }));
    }
    let min = moment().format("YYYY-MM-DD");
    if (isWeekEnd(min) || currentHours >= 15) {
      min = moment(min).add(1, "days").format("YYYY-MM-DD");
      setJobInfos((prev) => ({
        ...prev,
        job_date: min,
        job_time: dailySlot?.morning,
      }));
    }
    if (distance === undefined) {
      if (isWeekEnd(min)) {
        min = moment(min).add(1, "days").format("YYYY-MM-DD");
      }
      setJobInfos((prev) => ({
        ...prev,
        job_date: min,
      }));
      return min;
    }
    if (distance >= DISTANCES.D_300) {
      min = moment().add(3, "days").format("YYYY-MM-DD");
    } else if (DISTANCES.D_300 > distance && DISTANCES.D_100 <= distance) {
      min = moment().add(2, "days").format("YYYY-MM-DD");
    } else if (distance < DISTANCES.D_100 && distance >= DISTANCES.D_50) {
      min = moment().add(1, "days").format("YYYY-MM-DD");
    }
    if (isWeekEnd(min)) {
      min = moment(min).add(1, "days").format("YYYY-MM-DD");
    }
    setJobInfos((prev) => ({
      ...prev,
      job_date: min,
    }));
    return min;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [distance, currentHours]);

  const isDistanced = React.useMemo(() => distance >= DISTANCES.D_50, [distance]);

  const errorTime = () => {
    if (isNotPickup()) return false;
    if (isWeekEnd(jobInfos.job_date)) {
      const min = moment(jobInfos.job_date).add(1, "days").format("YYYY-MM-DD");
      setJobInfos((prev) => ({
        ...prev,
        job_date: min,
      }));
    }
    if (isCurrentDay(jobInfos.job_date)) {
      if (isAfternoom() && getHours(jobInfos.job_time) >= afternoonSlotStart) return true;
      if (!isMorning() && getHours(jobInfos.job_time) <= morningSlotStart) return true;
    }
    return false;
  };
  const disableVehicule = () => isNotPickup() || isDistanced;
  const vehiculeRodioColor = (vehicleType: string) => {
    if (vehicleType === JobVehicleType.Scooter || vehicleType === JobVehicleType.Tricycle)
      return disableVehicule() ? "#ececec" : "#707070";
    return isNotPickup() ? "#ececec" : "#707070";
  };

  const hasSunday = (start: Date, end: Date) => {
    const result = eachWeekendOfInterval({
      start,
      end,
    });
    return result.length !== 0 && result.length % 2 === 0;
  };
  const daysToAdd = (date: Date) => {
    let daysByDistance = 1;
    if (distance >= DISTANCES.D_300) {
      daysByDistance = 3;
    } else if (DISTANCES.D_300 > distance && DISTANCES.D_100 <= distance) {
      daysByDistance = 2;
    }
    const newDate = addDays(date, daysByDistance);
    const isSundayBeetween = hasSunday(date, newDate);
    return isSunday(newDate) || isSundayBeetween ? daysByDistance + 1 : daysByDistance;
  };
  const deliveryDateInfo = React.useMemo(() => {
    let infoText = "";
    if (isDistanced) {
      const days = daysToAdd(new Date(jobInfos.job_date));
      infoText = `${text.all.article_the} ${moment(jobInfos.job_date).add(days, "days").format("DD-MM-YYYY")}`;
    } else if (isToday(jobInfos.job_date)) {
      if (jobInfos.job_time === dailySlot?.morning && !errorTime()) {
        infoText = text.all.new_job_delivery_info_main_afternoon;
      }

      if (jobInfos.job_time === dailySlot?.afternoon && !errorTime()) {
        infoText = text.all.new_job_delivery_info_main_tomorrow;
      }

      if (jobInfos.job_type === JobType.Dropoff) {
        infoText = text.all.new_job_delivery_info_main_tomorrow;
      }
    } else {
      if (jobInfos.job_time === dailySlot?.morning && !errorTime()) {
        infoText = `${text.all.article_the} ${moment(jobInfos.job_date).format("DD-MM-YYYY")} ${text.all.new_job_delivery_info_main_afternoon_without_article
          }`;
      }
      if (jobInfos.job_time === dailySlot?.afternoon && !errorTime()) {
        const days = daysToAdd(new Date(jobInfos.job_date));
        infoText = `${text.all.article_the} ${moment(jobInfos.job_date).add(days, "days").format("DD-MM-YYYY")}`;
      }

      if (isNotPickup()) {
        const days = daysToAdd(new Date(jobInfos.job_date));
        infoText = `${text.all.article_the} ${moment(jobInfos.job_date).add(days, "days").format("DD-MM-YYYY")}`;
      }
    }
    return infoText;
  }, [isDistanced, minDay, jobInfos.job_date, jobInfos.job_time, jobInfos.job_type, text, distance]);

  const slots = React.useMemo(
    () => slotsPickup?.filter((slot) => slot.type === jobInfos.job_type),
    [jobInfos.job_type, slotsPickup]
  );

  return (
    <div className={styles.container}>
      <Grid container spacing={4} className={styles.root}>
        <Grid item xs={12}>
          <div className={styles.title}>
            <Typography color="primary" variant="h2" className={styles.step}>
              {text.all.step} 1
            </Typography>
          </div>

          <br />
          <Typography color="secondary" variant="h6" className={styles.subTitle}>
            {text.parcel.how_are_the_parcel}
          </Typography>
        </Grid>
        <Grid item xs={12} className={styles.radioGroup}>
          <FormControl component="fieldset" className={styles.fieldset}>
            <RadioGroup
              row
              aria-label="gender"
              name="job_type"
              value={jobInfos.job_type}
              onChange={onChange}
              className={styles.radioForm}
            >
              <Tooltip title={text.all.we_send_you_a_papser}>
                <FormControlLabel
                  value={JobType.Pickup}
                  control={<Radio color="primary" />}
                  label={text.all.pickup_label}
                />
              </Tooltip>
              <Tooltip title={text.all.drop_off}>
                <FormControlLabel
                  value={JobType.Dropoff}
                  control={<Radio color="primary" />}
                  label={text.all.drop_off_label}
                />
              </Tooltip>
              <Tooltip title={text.all.from_stock}>
                <FormControlLabel
                  value={JobType.FromStock}
                  control={<Radio color="primary" />}
                  label={text.all.from_stock_label}
                />
              </Tooltip>
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item sm={6} xs={12} className={styles.adresse}>
          <GeoAutoCompletion address={jobInfos?.job_address} onChange={handleAddressChange} disabled={isNotPickup()} />
        </Grid>
        <Grid className={styles.vehicleContainer} item xs={6}>
          <Grid item xs={12}>
            <label className={styles.vehicleLabel}>{text.all.vehicle}</label>
          </Grid>
          <FormControl
            component="fieldset"
            fullWidth
            css={`
              .MuiFormGroup-root {
                justify-content: space-between;
                margin: 10px 0px 10px 0px;
                ${theme.breakpoints.down("xs")} {
                  margin: 10px -22px 11px -6px;
                }
              }
              .MuiFormGroup-root {
                flex-wrap: wrap;
              }
            `}
            disabled={isNotPickup()}
            className={styles.formVehicle}
          >
            <RadioGroup
              row
              aria-label="gender"
              name="job_vehicle_type"
              value={jobInfos.job_vehicle_type}
              onChange={onChange}
            >
              <Tooltip title={text.vehicle.motocycle_tooltip}>
                <VehicleRadio
                  disabled={disableVehicule()}
                  value={JobVehicleType.Scooter}
                  icon={<MotorCycleIcon color={vehiculeRodioColor(JobVehicleType.Scooter)} />}
                  checkedIcon={<MotorCycleIcon color="#399ebf" />}
                />
              </Tooltip>

              <Tooltip title={text.vehicle.treecycle_tooltip}>
                <VehicleRadio
                  disabled={disableVehicule()}
                  value={JobVehicleType.Tricycle}
                  icon={<TreeCycleIcon color={vehiculeRodioColor(JobVehicleType.Tricycle)} />}
                  checkedIcon={<TreeCycleIcon color="#399ebf" />}
                />
              </Tooltip>

              <Tooltip title={text.vehicle.van_tooltip}>
                <VehicleRadio
                  value={JobVehicleType.MiniVan}
                  icon={<VanIcon color={vehiculeRodioColor(JobVehicleType.MiniVan)} />}
                  checkedIcon={<VanIcon color={!isNotPickup() ? "#399ebf" : "#ececec"} />}
                />
              </Tooltip>

              <Tooltip title={text.vehicle.vanXl_tooltip}>
                <VehicleRadio
                  value={JobVehicleType.Van}
                  icon={<VanXlIcon color={vehiculeRodioColor(JobVehicleType.Van)} />}
                  checkedIcon={<VanXlIcon color={!isNotPickup() ? "#399ebf" : "#ececec"} />}
                />
              </Tooltip>

              <Tooltip title={text.vehicle.truck_tooltip}>
                <VehicleRadio
                  value={JobVehicleType.Camion}
                  icon={<TruckIcon color={vehiculeRodioColor(JobVehicleType.Camion)} />}
                  checkedIcon={<TruckIcon color={!isNotPickup() ? "#399ebf" : "#ececec"} />}
                />
              </Tooltip>
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item sm={6} xs={12} className={styles.date}>
          <TextField
            type="date"
            fullWidth
            label="Date"
            name="job_date"
            value={jobInfos.job_date}
            onChange={onChange}
            inputProps={{ min: minDay }}
            className={styles.fieldDate}
          />
        </Grid>
        <Grid item sm={6} xs={12} className={styles.creneau}>
          <FormControl
            variant="outlined"
            fullWidth
            error={errorTime()}
            disabled={isDistanced && jobInfos?.job_type === JobType.Pickup}
            css={`
              background-color: ${isDistanced && jobInfos?.job_type === JobType.Pickup ? "#ececec" : "inherate"};
              ${theme.breakpoints.down("xs")} {
                top: -24px;
              }
            `}
          >
            <InputLabel id="demo-simple-select-outlined-label">{text.all.time}</InputLabel>
            <Select
              css={`
                ${theme.breakpoints.down("xs")} {
                  width: auto;
                }
              `}
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={jobInfos.job_time}
              label={text.all.time}
              name="job_time"
              onChange={(e) =>
                setJobInfos((prev) => ({
                  ...prev,
                  job_time: e.target.value as string,
                }))
              }
            >
              {slots.map((slot) => (
                <MenuItem value={slot.start}>{slot.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {deliveryDateInfo && jobInfos?.job_type !== JobType.FromStock && (
          <Grid item xs={12}>
            <Alert severity="info" className={styles.deliveryDateInfo}>
              <Typography color="secondary" variant="h6">
                {text.all.new_job_delivery_info_main} <span className={styles.boldText}>{deliveryDateInfo}</span> .
              </Typography>
            </Alert>
          </Grid>
        )}
        <Grid className={styles.globalButton}>
          <Button
            className={styles.button}
            color="primary"
            variant="contained"
            onClick={handleNext}
            disabled={!isValidForm() || errorTime()}
          >
            {text.all.next}
          </Button>
        </Grid>
      </Grid>
      {open && <HolidaysDialog onClose={() => setOpen(false)} />}
    </div>
  );
}

export default NewJobInfos;
